import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import LegalAcceptanceModal from '../components/dialogs/LegalAcceptanceModal';
import SampleCreationManager from '../components/sampleCreationManager/SampleCreationManager';
import UploadManager from '../components/uploadManager/UploadManager';
import { SampleCreationProvider } from '../contexts/SampleCreationContext';
import { UploadProvider } from '../contexts/UploadContext';
import { UserProvider, useUser } from '../contexts/UserContext';
import { setUserContext, startSessionReplayIfExternal } from '../utils/datadog';
import { identifyPendoUser } from '../utils/pendo';
import { authenticatedBeforeLoad } from './-authenticatedBeforeLoad';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: authenticatedBeforeLoad,
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <UserProvider>
      <SampleCreationProvider>
        <UploadProvider>
          <OpenFeatureProvider suspendUntilReady={false}>
            <AuthenticatedContent />
          </OpenFeatureProvider>
        </UploadProvider>
      </SampleCreationProvider>
    </UserProvider>
  );
}

function AuthenticatedContent() {
  const { userData } = useUser();

  useEffect(() => {
    if (!userData) {
      return;
    }
    setUserContext({
      id: userData.id,
      email: userData.email,
      name: userData.name,
      role: userData.role_name || 'user',
      organization: userData.org?.name,
      permissions: userData.permissions,
    });
    startSessionReplayIfExternal(userData.email);
    identifyPendoUser({
      id: userData.id,
      email: userData.email,
      name: userData.name,
      roles: userData.roles,
      organization: userData.org
        ? { id: userData.org.id, name: userData.org.name }
        : undefined,
      permissions: userData.permissions,
    });
  }, [userData]);

  return (
    <>
      <LegalAcceptanceModal />
      <UploadManager />
      <SampleCreationManager />
      <Outlet />
    </>
  );
}
